import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchProjects, fetchTechnologies, fetchProjectCategories } from '../../services/api';
import { updateProject, uploadImage } from '../../services/adminApi';
import Loader from '../../components/admin/ui/Loader';
import EntityForm from '../../components/admin/EntityForm';
import EntityFormPage from '../../components/admin/EntityFormPage';
import { getProjectFields, projectToFormValues, projectToPayload } from '../../config/admin/projects.config';

function AdminProjectEditPage({ showToast }) {
  const { seturl } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [categories, setCategories] = useState([]);
  const [technologies, setTechnologies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    Promise.all([fetchProjects(), fetchProjectCategories(), fetchTechnologies()]).then(
      ([projects, categoriesData, technologiesData]) => {
        if (!mounted) return;
        setProject((projects || []).find((p) => p.seturl === seturl) || null);
        setCategories(categoriesData ?? []);
        setTechnologies(technologiesData?.items ?? []);
        setLoading(false);
      }
    );
    return () => {
      mounted = false;
    };
  }, [seturl]);

  const handleImageUpload = async (file) => {
    const result = await uploadImage(file);
    return result.path;
  };

  const handleSubmit = async (values) => {
    await updateProject(project.id, projectToPayload(values));
    showToast('Projet mis à jour.');
    navigate('/admin-bj/projets');
  };

  if (loading) return <Loader label="Chargement du projet..." />;

  if (!project) {
    return (
      <EntityFormPage listLabel="Projets" title="Projet introuvable" onBack={() => navigate('/admin-bj/projets')}>
        <p>Aucun projet avec le slug « {seturl} ».</p>
      </EntityFormPage>
    );
  }

  return (
    <EntityFormPage
      listLabel="Projets"
      itemLabel={project.nom?.fr || project.nom?.en}
      title="Modifier le projet"
      onBack={() => navigate('/admin-bj/projets')}
    >
      <EntityForm
        key={project.id}
        fields={getProjectFields(technologies, categories)}
        initialValues={projectToFormValues(project)}
        onSubmit={handleSubmit}
        onUpload={handleImageUpload}
        submitLabel="Sauvegarder"
      />
    </EntityFormPage>
  );
}

export default AdminProjectEditPage;
